const { busApi } = require('./API');

class FormService {
  // List All Forms
  static async listForms(businessId, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    const res = await busApi.get(`${businessId}/forms`);
    const { data } = res;
    return data;
  }
}

export default FormService;
